export const USER_LOGOUT = 'USER_LOGOUT'

export const AuthConstants = {
    LOGIN: 'AUTH_LOGIN',
    LOGOUT: 'AUTH_LOGOUT',
    FAILED: 'AUTH_FAILED',
    AUTH: 'CHECK_USER_AUTH',
    UPDATE: 'UPDATE_PROFILE',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    REFRESH_TOKEN_FAILED: 'REFRESH_TOKEN_FAILED',
    CLEAR: 'AUTH_CLEAR',
    STATS: 'GET_DASHBOARD_STATS'
}


export const DepartmentConstants = {
    GET: 'GET_DEPARTMENTS',
    ADD: 'ADD_DEPARTMENT',
    UPDATE: 'UPDATE_DEPARTMENT',
    DELETE: 'DELETE_DEPARTMENT',
    FAIL: 'FAIL_DEPARTMENTS',
    CLEAR: 'CLEAR_DEPARTMENTS',
    LOADING: 'DEPARTMENTS_LOADING'
}

export const RoleConstants = {
    GET: 'GET_ROLES',
    ADD: 'ADD_ROLES',
    UPDATE: 'UPDATE_ROLE',
    DELETE: 'DELETE_ROLE',
    FAIL: 'FAIL_ROLES',
    CLEAR: 'CLEAR_ROLES',
    LOADING: 'ROLES_LOADING',
    RESOURCES: 'GET_RESOURCES'
}

export const UserConstants = {
    GET: 'GET_USERS',
    ADD: 'ADD_USER',
    UPDATE: 'UPDATE_USER',
    DELETE: 'DELETE_USER',
    FAIL: 'FAIL_USERS',
    CLEAR: 'CLEAR_USERS',
    LOADING: 'USERS_LOADING'
}

export const ClientUserConstants = {
    GET: 'GET_CLIENT_USERS',
    ADD: 'ADD_CLIENT_USER',
    UPDATE: 'UPDATE_CLIENT_USER',
    DELETE: 'DELETE_CLIENT_USER',
    FAIL: 'FAIL_CLIENT_USERS',
    CLEAR: 'CLEAR_CLIENT_USERS',
    LOADING: 'USERS_CLIENT_LOADING'
}

export const ClientConstants = {
    GET: 'GET_CLIENT',
    ADD: 'ADD_CLIENT',
    UPDATE: 'UPDATE_CLIENT',
    DELETE: 'DELETE_CLIENT',
    DETAILS: 'CLIENT_DETAILS',
    FAIL: 'FAIL_CLIENTS',
    CLEAR: 'CLEAR_CLIENT',
    LOADING: 'CLIENT_LOADING'
}

export const BranchConstants = {
    GET: 'GET_BRANCHES',
    ADD: 'ADD_BRANCHE',
    UPDATE: 'UPDATE_BRANCHE',
    DELETE: 'DELETE_BRANCHE',
    DETAILS: 'BRANCHE_DETAILS',
    FAIL: 'FAIL_BRANCHES',
    CLEAR: 'CLEAR_BRANCHES',
    LOADING: 'BRANCHES_LOADING'
}


export const ConsumerConstants = {
    GET: 'GET_CONSUMER',
    ADD: 'ADD_CONSUMER',
    UPDATE: 'UPDATE_CONSUMER',
    DELETE: 'DELETE_CONSUMER',
    FAIL: 'FAIL_CONSUMER',
    IMPORT: 'IMPORT_CONSUMER',
    EXPORT: 'EXPORT_CONSUMER',
    CLEAR: 'CLEAR_CONSUMER',
    LOADING: 'CONSUMER_LOADING'
}

export const ClientConsumerConstants = {
    GET: 'GET_CLIENT_CONSUMERS',
    ADD: 'ADD_CLIENT_CONSUMER',
    UPDATE: 'UPDATE_CLIENT_CONSUMER',
    DELETE: 'DELETE_CLIENT_CONSUMERS',
    FAIL: 'FAIL_CLIENT_CONSUMERS',
    IMPORT: 'IMPORT_CLIENT_CONSUMERS',
    EXPORT: 'EXPORT_CLIENT_CONSUMERS',
    CLEAR: 'CLEAR_CLIENT_CONSUMERS',
    LOADING: 'CLIENT_CONSUMERS_LOADING'
}

export const ClientPaymentAccountConstants = {
    GET: 'GET_ACCOUNT',
    ADD: 'ADD_ACCOUNT',
    CREDIT: 'CREDIT_ACCOUNT',
    UPDATE: 'UPDATE_ACCOUNT',
    DELETE: 'DELETE_ACCOUNT',
    FAIL: 'FAIL_ACCOUNT',
    CLEAR: 'CLEAR_ACCOUNT',
    LOADING: 'CLIENT_PAYMENT_ACCOUNTS_LOADING',
}

export const BillConstants = {
    GET: 'GET_BILLS',
    SEARCH: 'SEARCH_BILLS',
    ADD: 'ADD_BILL',
    UPDATE: 'UPDATE_BILL',
    DELETE: 'DELETE_BILL',
    FAIL: 'FAIL_BILLS',
    CLEAR: 'CLEAR_BILLS',
    MONTHS: 'GET_BILLING_MONTHS',
    LOADING: 'BILL_LOADING',
    EXPORT: 'BILL_EXPORT'
}

export const ClientBillConstants = {
    GET: 'GET_CLIENT_BILLS',
    ADD: 'ADD_CLIENT_BILL',
    UPDATE: 'UPDATE_CLIENT_BILL',
    DELETE: 'DELETE_CLIENT_BILL',
    FAIL: 'FAIL_CLIENT_BILLS',
    CLEAR: 'CLEAR_CLIENT_BILLS',
    MONTHS: 'GET_CLIENT_BILLING_MONTHS',
    LOADING: 'CLIENT_BILL_LOADING'
}

export const NotificationConstants = {
    GET: 'GET_NOTIFICATIONS',
    ADD: 'ADD_NOTFICATION',
    UPDATE: 'UPDATE_NOTFICATION',
    DELETE: 'DELETE_NOTFICATION',
    FAIL: 'FAIL_NOTFICATIONS',
    CLEAR: 'CLEAR_NOTFICATIONS',
}

export const PaymentTransactionConstants = {
    GET: 'GET_TRANSACTION',
    ADD: 'ADD_TRANSACTION',
    UPDATE: 'UPDATE_TRANSACTION',
    DELETE: 'DELETE_TRANSACTION',
    STATS: 'GET_TRANSACTION_STATS',
    EXPORT: 'EXPORT_TRANSACTION',
    FAIL: 'FAIL_TRANSACTION',
    CLEAR: 'CLEAR_TRANSACTION',
}

export const ConfigConstants = {
    GET: 'GET_CONFIG',
    UPDATE: 'UPDATE_CONFIG',
    DELETE: 'DELETE_CONFIG',
    FAIL: 'FAIL_CONFIG',
    CLEAR: 'CLEAR_CONFIG',
    LOADING: 'CONFIG_LOADING'
}

export const CollectionMethodConstants = {
    GET: 'GET_COLLECTION_METHODS',
    FAIL: 'FAIL_COLLECTION_METHODS',
    LOADING: 'COLLECTION_METHODS_LOADING',
}

export const GatewayMerchantAccountConstants = {
    GET: 'GET_GATEWAY_MERCHANT_ACCOUNTS',
    FAIL: 'FAIL_GATEWAY_MERCHANT_ACCOUNTS',
    LOADING: 'GATEWAY_MERCHANT_ACCOUNTS_LOADING',
}

export const ClientGatewayAccountConstants = {
    GET: 'GET_CLIENT_GATEWAY_ACCOUNTS',
    FAIL: 'FAIL_CLIENT_GATEWAY_ACCOUNTS',
    LOADING: 'CLIENT_GATEWAY_ACCOUNTS_LOADING',
}

export const BillerNetworkAccountConstants = {
    GET: 'GET_BILLER_NETWORK_ACCOUNTS',
    FAIL: 'FAIL_BILLER_NETWORK_ACCOUNTS',
    LOADING: 'BILLER_NETWORK_ACCOUNTS_LOADING',
}